import MobileNav from "./MobileNav";
import Nav from "./Nav";

const UserNav = () => {
  return (
    <>
      <Nav />
      <MobileNav />
    </>
  );
};

export default UserNav;
